// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".datepickerInput {\n  padding-left: 0px !important;\n}\n", "",{"version":3,"sources":["webpack://app/global/ui/xsDatePicker/xsDatePicker.less"],"names":[],"mappings":"AAAA;EACC,4BAAA;AACD","sourcesContent":[".datepickerInput {\n\tpadding-left: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
